import { Observable, from } from 'rxjs';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccountCenterService } from './account-center.service';

@Injectable()
export class AccountCenterResolver implements Resolve<Observable<string>> {
  constructor(private accountCenterService: AccountCenterService) {}

  resolve(
    activatedRouteSnapshot: ActivatedRouteSnapshot,
    routerStateSnapshot: RouterStateSnapshot
  ): Observable<string> {
    return from(this.accountCenterService.dispatchStatus());
  }
}
